var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_690_5130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.125 13.5625C20.125 12.586 19.5843 11.7425 18.7933 11.291C19.5493 11.0985 20.125 10.4405 20.125 9.625C20.125 9.34675 20.055 9.086 19.9342 8.86025C19.4915 7.322 18.4958 6.041 17.171 5.25H10.829C9.5025 6.041 8.5085 7.322 8.064 8.86025C7.945 9.08775 7.875 9.3485 7.875 9.625C7.875 10.4387 8.45075 11.0968 9.20675 11.2893C8.41575 11.7425 7.875 12.586 7.875 13.5625C7.875 14.5408 8.41575 15.3825 9.2085 15.8357C8.449 16.0265 7.875 16.6827 7.875 17.5V26.25C7.875 27.216 8.659 28 9.625 28H18.375C19.341 28 20.125 27.216 20.125 26.25V17.5C20.125 16.681 19.551 16.0248 18.7915 15.834C19.5842 15.3825 20.125 14.5408 20.125 13.5625Z",
    fill: "#80C9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.625 0H11.375C10.892 0 10.5 0.392 10.5 0.875V2.625C10.5 3.108 10.892 3.5 11.375 3.5H16.625C17.108 3.5 17.5 3.108 17.5 2.625V0.875C17.5 0.392 17.108 0 16.625 0Z",
    fill: "#80C9C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_690_5130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.009135d528bcd4fbc36f96c4152dde9b.svg";
export { ForwardRef as ReactComponent };